import React, { useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import {
  Paper,
  Box,
  Typography,
  makeStyles,
  Grid,
  IconButton,
} from "@material-ui/core";
import KenInput from "../../../components/KenInputField";
import KenSelect from "../../../components/KenSelect";
import KenButton from "../../../components/KenButton";
import { otpGenerator } from "../../../utils/Otp";
import clsx from "clsx";
import KenCheckbox from "../../../components/KenCheckbox";
import { createContact, getContactInfo } from "../../../utils/ApiService";
import * as Yup from "yup";
import { withFormik } from "formik";
import "../../../themes/styles.scss";
import configContext from '../../../utils/config';
import Validation from "../../../utils/ValidationMessages";
import DialogBox from "./DialogBox";
import CloseIcon from "../../../assets/icons/Cross.png";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "relative",
  },
  hide: {
    display: "none",
  },
  reSend: {
    cursor: "pointer",
    float: "right",
  },
  Heading: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.KenColors.neutral100,
    textAlign: "left",
    textTransform: "uppercase",
    marginBottom: 24,
  },
  change: {
    cursor: "pointer",
    color: "#f69e22",
    fontSize: "15px",
  },
  registerLabel: {
    textAlign: "start",
    marginBottom: "10px",
    color: theme.palette.KenColors.black,
    textTransform: "capitalize",
    fontWeight: "600",
    fontSize: 16,
  },
  applyLabel: {
    fontSize: 14,
  },
  closeButtonContainer: {
    position: "absolute",
    top: "-16px",
    right: "-16px",
  },
}));

const relations = [
  {
    label: "Father",
    value: "Father",
  },
  {
    label: "Mother",
    value: "Mother",
  },
  {
    label: "Guardian",
    value: "Guardian",
  },
];

export default withRouter(function ExistingInfo(props) {
  //console.log('[SignInInfo] props', props);
  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
});

const ExistingForm = (props) => {
  // console.log("props from existingForm",props);
  const {
    toggle,
    retrieve,
    options,
    handleSnackbarOpen,
    values,
    touched,
    errors,
    handleChange,
    setFieldTouched,
    currentRow,
    handleSubmit,
    setFieldValue,
    handleClose,
    relationWithApplicant,
    applyingForMe,
  } = props;
  const {config} = React.useContext(configContext);

  console.log(props, "existingProps");

  console.log(relationWithApplicant, applyingForMe, "relationWithApplicant");

  // const mobile = localStorage.getItem("userPhone");
  const classes = useStyles();
  const [otp, setOtp] = React.useState();
  const [showOtpEnter, setShowOtpEnter] = React.useState(false);
  const [myself] = React.useState(true);
  // const [phone, setPhone] = useState(mobile);
  const [phone] = useState(localStorage.getItem("userPhone"));
  const [email] = useState();
  const [applyingForSelf, setApplyingForSelf] = useState(applyingForMe);
  const [contactID, setContactID] = useState();
  const [relation, setRelation] = useState(values.Relation);
  const history = useHistory();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [emailId, setEmailId] = useState();

  // const handleDialogSubmit = () => {
  //   setOpenDialog(false);
  // };

  const apply = () => {
    console.log("values from[handleSubmit]", values);
    const signInPayload = {
      Phone: localStorage.getItem("userPhone"),
    };

    createContact(signInPayload)
      .then((resp) => {
        localStorage.setItem("applyingForSelf", applyingForSelf);
        // console.log("contact id by phone", resp);
        // alert("1.you are applying for : " + currentRow.academicProgram);

        getContactInfo(resp.ContactId).then((data) => {
          localStorage.setItem("firstName", data.First_Name);
          localStorage.setItem("lastName", data.Last_Name);
          history.push({
            pathname: `/intro/${currentRow.programId}`,
            search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
            state: {
              academicProgramDetails: currentRow,
              userDetails: {
                ...data,
                phoneNumber: localStorage.getItem("userPhone"),
                email: data.Email,
                relationWithApplicant: values.Relation,
                contactID: resp.ContactId,
                applyingForSelf: values.applyingForSelf,
                ApplicantAccount: resp.ApplicantAccount,
                RelationsAccount: resp.RelationsAccount,
                First_Name: data.First_Name,
                Last_Name: data.Last_Name,
              },
              applicationDetails: {
                draft: false,
              },
              ParentId: resp.ContactId,
              Email: data.Email,
            },
          });
          // state: `${programID}`
        });
      })
      .catch((error) => {
        console.log("Error in modal while create contact", error);
      });
  };

  const handleApplyForSelf = (e) => {
    setApplyingForSelf(e.target.checked);
    setFieldValue("applyingForSelf", e.target.checked);
    setFieldValue("Relation", "");
    touched.Relation = false;
  };

  //console.log("current row in existing", currentRow);
  React.useEffect(() => {
    if (otp) {
      alert(`Please note down the OTP for further process. The OTP is ${otp}`);
    }
  }, [otp]);

  const change = (name, e, index) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  const handleRetrieval = () => {
    const signInPayload = {
      Phone: values.PhoneNumber,
    };

    if (values.PhoneNumber.length === 10) {
      createContact(signInPayload)
        .then((resp) => {
          getContactInfo(resp.ContactId)
            .then((resp) => {
              // console.log("resp of getInfo", resp);
              setEmailId(resp.Email);
            })
            .catch((err) => {
              console.log("error in getInfo[handle retrival]", err);
            });
        })
        .catch((err) => {
          console.log("error in create contact[handle retrival]", err);
        });

      if (config.smsURL) {
        let access_token = localStorage.getItem("access_token");
        fetch(
          // `${applicationConfig.smsURL}/validateotp?mobileno=${values.PhoneNumber}&otp=${values.userOTP}`,
          // `${applicationConfig.smsURL}/validateotp?email=${emailId}&mobileno=${values.PhoneNumber}&otp=${values.userOTP}`,
          `${config.smsURL}/validateotp?email=${emailId}&otp=${values.userOTP}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
          }
        )
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);
            if (data.status) {
              createContact(signInPayload)
                .then((resp) => {
                  setContactID(resp.ContactId);
                  setApplyingForSelf(true);
                  setRelation(values.Relation || "self");
                  if (
                    resp.contactType === "Existing" &&
                    resp.ContactId !== "null"
                  ) {
                    localStorage.setItem("userPhone", values.PhoneNumber);
                    localStorage.setItem("userEmail", emailId);
                    // console.log("valid contactId", resp);
                    getContactInfo(resp.ContactId).then((data) => {
                      // console.log(data)
                      localStorage.setItem("firstName", data.First_Name);
                      localStorage.setItem("lastName", data.Last_Name);
                      history.push({
                        pathname: "/applications",
                        state: {
                          userDetails: {
                            ...data,
                            phoneNumber: values.PhoneNumber,
                            email: data.Email,
                            relationWithApplicant:
                              values.Relation ||
                              localStorage.getItem("relation") ||
                              "self",
                            contactID: resp.ContactId,
                            applyingForSelf: values.applyingForSelf,
                            ApplicantAccount: resp.ApplicantAccount,
                            RelationsAccount: resp.RelationsAccount,
                            First_Name: data.First_Name,
                            Last_Name: data.Last_Name,
                          },
                          applicationDetails: {
                            draft: false,
                          },
                          ParentId: resp.ContactId,
                          Email: data.Email,
                        },
                      });
                    });
                  } else {
                    handleSnackbarOpen(
                      "error",
                      "Already Registered with same Email or Mobile"
                    );
                  }
                })
                .catch((error) => {
                  console.log("Error [Existing] Create Contact:", error);
                });
            } else {
              handleSnackbarOpen("error", "Invalid OTP. Please try again.");
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        if (otp === props.values.userOTP) {
          createContact(signInPayload)
            .then((resp) => {
              setContactID(resp.ContactId);
              setApplyingForSelf(true);
              setRelation(values.Relation || "self");
              if (
                resp.contactType === "Existing" &&
                resp.ContactId !== "null"
              ) {
                localStorage.setItem("userPhone", values.PhoneNumber);
                localStorage.setItem("userEmail", emailId);
                getContactInfo(resp.ContactId).then((data) => {
                  // console.log(data)
                  localStorage.setItem("firstName", data.First_Name);
                  localStorage.setItem("lastName", data.Last_Name);
                  history.push({
                    pathname: "/applications",
                    state: {
                      userDetails: {
                        ...data,
                        phoneNumber: values.PhoneNumber,
                        email: data.Email,
                        relationWithApplicant:
                          values.Relation ||
                          localStorage.getItem("relation") ||
                          "self",
                        contactID: resp.ContactId,
                        applyingForSelf: values.applyingForSelf,
                        ApplicantAccount: resp.ApplicantAccount,
                        RelationsAccount: resp.RelationsAccount,
                        First_Name: data.First_Name,
                        Last_Name: data.Last_Name,
                      },
                      applicationDetails: {
                        draft: false,
                      },
                      ParentId: resp.ContactId,
                      Email: data.Email,
                    },
                  });
                });
              } else {
                // console.log("invalid phoneNumber");
                handleSnackbarOpen(
                  "error",
                  "Already Registered with same Email or Mobile"
                );
              }
            })
            .catch((error) => {
              //setLoading(false);
              console.log("Error [Existing] Create Contact:", error);
            });
        } else {
          handleSnackbarOpen("error", "Invalid OTP. Please try again.");
          setShowOtpEnter(true);
        }
      }
    } else {
      // console.log("invalid phone number",values.PhoneNumber.length);
      handleSnackbarOpen("error", "Invalid Mobile/Phone number");
    }
  };

  const handleOtp = () => {
    console.log("handle otp");
    const signInPayload = {
      Email: email,
      Phone: values.PhoneNumber || localStorage.getItem("userPhone"),
    };
    if (values.PhoneNumber.length === 10) {
      createContact(signInPayload)
        .then((resp) => {
          getContactInfo(resp.ContactId)
            .then((resp) => {
              // console.log("resp of getInfo", resp);
              setEmailId(resp.Email);
              if (config.smsURL) {
                setShowOtpEnter(true);
                let access_token = localStorage.getItem("access_token");
                console.log("access_token", access_token);
                fetch(
                  // `${applicationConfig.smsURL}/otp?mobileno=${values.PhoneNumber}`,
                  // `${applicationConfig.smsURL}/otp?email=${resp.Email}&mobileno=${values.PhoneNumber}`,
                  `${config.smsURL}/otp?email=${resp.Email}`,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${access_token}`,
                    },
                  }
                )
                  .then((response) => response.text())
                  .then((result) => {
                    console.log(result);
                  })
                  .catch((error) => console.log("error", error));
              } else {
                setShowOtpEnter(true);
                setOtp(otpGenerator());
              }
            })
            .catch((err) => {
              console.log("error in getInfo[handle login]", err);
            });
        })
        .catch((err) => {
          console.log("error in create contact[handle login]", err);
        });
    } else {
      handleSnackbarOpen("error", "Mobile Number should have 10 Digits");
    }
  };

  const handleLogin = () => {
    // console.log("handle login");
    // setOpenDialog(true);
    const signInPayload = {
      Email: email,
      Phone: values.PhoneNumber || localStorage.getItem("userPhone"),
    };

    //console.log('signInPayload', signInPayload);

    if (values.PhoneNumber.length === 10) {
      createContact(signInPayload)
        .then((resp) => {
          getContactInfo(resp.ContactId)
            .then((resp) => {
              // console.log("resp of getInfo", resp);
              setEmailId(resp.Email);
            })
            .catch((err) => {
              console.log("error in getInfo[handle login]", err);
            });
        })
        .catch((err) => {
          console.log("error in create contact[handle login]", err);
        });

      if (config.smsURL) {
        let access_token = localStorage.getItem("access_token");
        fetch(
          // `${applicationConfig.smsURL}/validateotp?mobileno=${values.PhoneNumber}&otp=${values.userOTP}`,
          // `${applicationConfig.smsURL}/validateotp?email=${emailId}&mobileno=${values.PhoneNumber}&otp=${values.userOTP}`,
          `${config.smsURL}/validateotp?email=${emailId}&otp=${values.userOTP}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
          }
        )
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);
            if (data.status) {
              createContact(signInPayload)
                .then((resp) => {
                  if (
                    resp.contactType === "Existing" &&
                    resp.ContactId !== "null"
                  ) {
                    localStorage.setItem("userPhone", values.PhoneNumber);
                    localStorage.setItem("userEmail", emailId);
                    localStorage.setItem("contactID", resp.ContactId);
                    getContactInfo(resp.ContactId).then((data) => {
                      console.log(data);
                      localStorage.setItem("firstName", data.First_Name);
                      localStorage.setItem("lastName", data.Last_Name);
                      history.push({
                        pathname: `/intro/${currentRow.programId}`,
                        search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
                        state: {
                          academicProgramDetails: currentRow,
                          userDetails: {
                            ...data,
                            phoneNumber: values.PhoneNumber,
                            email: data.Email,
                            relationWithApplicant: values.Relation || "self",
                            contactID: resp.ContactId,
                            applyingForSelf: values.applyingForSelf,
                            contactType: resp.contactType,
                            ApplicantAccount: resp.ApplicantAccount,
                            RelationsAccount: resp.RelationsAccount,
                            First_Name: data.First_Name,
                            Last_Name: data.Last_Name,
                          },
                          applicationDetails: {
                            draft: false,
                          },
                          ParentId: resp.ContactId,
                          Email: data.Email,
                        },
                      });
                    });
                  } else {
                    handleSnackbarOpen(
                      "error",
                      "Already Registered with same Email or Mobile"
                    );
                  }
                })
                .catch((error) => {
                  //setLoading(false);
                  console.log("Error [Existing] Create Contact:", error);
                });
            } else {
              handleSnackbarOpen("error", "Invalid OTP. Please try again.");
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        if (otp === values.userOTP) {
          createContact(signInPayload)
            .then((resp) => {
              if (
                resp.contactType === "Existing" &&
                resp.ContactId !== "null"
              ) {
                localStorage.setItem("userPhone", values.PhoneNumber);
                localStorage.setItem("userEmail", emailId);
                localStorage.setItem("contactID", resp.ContactId);
                getContactInfo(resp.ContactId).then((data) => {
                  console.log(data);
                  localStorage.setItem("firstName", data.First_Name);
                  localStorage.setItem("lastName", data.Last_Name);
                  history.push({
                    pathname: `/intro/${currentRow.programId}`,
                    search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
                    state: {
                      academicProgramDetails: currentRow,
                      userDetails: {
                        ...data,
                        phoneNumber: values.PhoneNumber,
                        email: data.Email,
                        relationWithApplicant: values.Relation || "self",
                        contactID: resp.ContactId,
                        applyingForSelf: values.applyingForSelf,
                        contactType: resp.contactType,
                        ApplicantAccount: resp.ApplicantAccount,
                        RelationsAccount: resp.RelationsAccount,
                        First_Name: data.First_Name,
                        Last_Name: data.Last_Name,
                      },
                      applicationDetails: {
                        draft: false,
                      },
                      ParentId: resp.ContactId,
                      Email: data.Email,
                    },
                  });
                });
              } else {
                handleSnackbarOpen(
                  "error",
                  "Already Registered with same Email or Mobile"
                );
                toggle();
              }
            })
            .catch((error) => {
              //setLoading(false);
              console.log("Error [Existing] Create Contact:", error);
            });
        } else {
          handleSnackbarOpen("error", "Invalid OTP. Please try again.");
        }
      }
    } else {
      //console.log("enter a valid phone Number");
      handleSnackbarOpen("error", "Mobile/Phone Number should have 10 Numbers");
    }
  };

  return (
    <form>
      {currentRow && (
        <DialogBox
          title={`CONFIRMATION`}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          message="Do you want to continue?"
          okText="Yes"
          notOkText="No"
          width={"sm"}
          // handleDialogSubmit={phone && !retrieve ? handleSubmit : handleLogin}
          handleDialogSubmit={apply}
        >
          <Typography style={{ marginBottom: 8 }}>
            You are applying for Academic program{" "}
            <span style={{ color: "#000000", fontWeight: 600 }}>
              {currentRow.academicProgram}
            </span>
          </Typography>
        </DialogBox>
      )}
      <Paper className={classes.paper} elevation={0}>
        <Box pt={1} className={classes.closeButtonContainer}>
          <IconButton aria-label="delete" color="primary" onClick={handleClose}>
            <img src={CloseIcon}></img>
          </IconButton>
        </Box>
        <Box textAlign="center">
          <Box pt={1}>
            <Typography
              variant="body2"
              className={classes.registerLabel}
              style={{ fontSize: "14px" }}
            >
              {phone && !retrieve ? (
                <span className={classes.applyLabel}>APPLY</span>
              ) : (
                <span>SIGN IN</span>
              )}
            </Typography>
          </Box>
          <Box pt={1}>
            <div className={clsx({ [classes.hide]: !myself })}>
              <Grid container spacing={1}>
                {phone && !retrieve ? null : (
                  <Grid item xs={12} sm={12} md={12}>
                    <KenInput
                      required
                      label="Phone Number"
                      name="PhoneNumber"
                      startAdornment
                      onChange={change.bind(null, "PhoneNumber")}
                      value={values.PhoneNumber}
                      errors={errors.PhoneNumber}
                      touched={touched.PhoneNumber}
                      startAdornmentIcon={
                        <div
                          style={{ marginTop: "-2px", marginBottom: "-4px" }}
                        >
                          <KenSelect
                            // required
                            options={options}
                            defaultValue={() => {
                              return "+91";
                            }}
                          />
                        </div>
                      }
                    />
                  </Grid>
                )}

                {!values.applyingForSelf && !retrieve ? (
                  <Grid item xs={12} sm={12} md={12}>
                    <KenSelect
                      label="Relation"
                      name="Relation"
                      options={relations}
                      onChange={change.bind(null, "Relation")}
                      required={true}
                      value={values.Relation || ""}
                      errors={errors.Relation}
                      touched={touched.Relation}
                    />
                  </Grid>
                ) : null}

                {retrieve ? null : (
                  <Grid>
                    <div className="applyselfLabel">
                      <KenCheckbox
                        label="Applying for self"
                        name="applyingForSelf"
                        value={values.applyingForSelf}
                        onChange={(e) => {
                          handleApplyForSelf(e);
                        }}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            </div>
          </Box>

          {phone && !retrieve ? null : (
            <Box
              className={clsx({
                [classes.hide]: showOtpEnter,
              })}
              pt={1}
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
            >
              <KenButton
                variant="secondary"
                onClick={() => {
                  handleOtp();
                }}
              >
                Get OTP
              </KenButton>
            </Box>
          )}
          {phone && !retrieve ? (
            <Box
              display="flex"
              justifyContent="flex-end"
              onClick={() => {
                setOpenDialog(true);
              }}
            >
              <KenButton variant="primary">Go</KenButton>
              {/* </Link> */}
            </Box>
          ) : null}

          <div className={clsx({ [classes.hide]: !showOtpEnter })}>
            <Box pt={1}>
              <Typography
                color="primary"
                className={classes.reSend}
                onClick={() => {
                  handleOtp();
                }}
              >
                Resend-OTP
              </Typography>
              <KenInput
                // required
                label="Enter OTP"
                name="userOTP"
                onChange={change.bind(null, "userOTP")}
                value={values.userOTP}
                errors={errors.userOTP}
                touched={touched.userOTP}
              />
            </Box>

            <div>
              {retrieve === true ? (
                <Box pt={1} display="flex" justifyContent="flex-end">
                  <KenButton variant="primary" onClick={handleRetrieval}>
                    GO
                  </KenButton>
                </Box>
              ) : (
                <Box pt={1} display="flex" justifyContent="flex-end">
                  <KenButton
                    variant="primary"
                    onClick={() => setOpenDialog(true)}
                  >
                    GO
                  </KenButton>
                </Box>
              )}
            </div>
            <div></div>
          </div>
        </Box>

        <Box
          className={clsx({ [classes.hide]: retrieve })}
          pt={1}
          display="flex"
          justifyContent="center"
        >
          {!phone ? (
            <Typography
              variant="body2"
              className={classes.change}
              onClick={toggle}
            >
              Register yourself
            </Typography>
          ) : null}
        </Box>
      </Paper>
    </form>
  );
};

const FormikHoc = (props) => {
  const history = useHistory();
  //console.log('props of signIN modal',props);
  const { handleSnackbarOpen, currentRow } = props;
  const {config} = React.useContext(configContext);
  const applyingForSelf = config.isApplyingForSelf;
  // const relationWA= props.relationWithApplicant;
  // const applyingForWhom= props.applyingForMe;
  const numberRegExp = /^[0-9]*$/;
  console.log("props.applyingForMe", props.applyingForMe);
  //console.log("isApplyingForSelf", isApplyingForSelf);
  const ExistingFormik = withFormik({
    mapPropsToValues: () => ({
      PhoneNumber: localStorage.getItem("userPhone") || "",
      userOTP: "",
      applyingForSelf:
        props.applyingForMe != undefined ? props.applyingForMe : true,
      Relation: props.relationWithApplicant,
    }),

    validationSchema: Yup.object({
      PhoneNumber: Yup.string()
        .required()
        .matches(numberRegExp, `${Validation.phone.invalid}`)
        .test("len", `${Validation.phone.digits}`, (val) => {
          if (val) {
            return val.toString().length === 10;
          }
        }),
      Relation: Yup.string().when("applyingForSelf", {
        is: false,
        then: Yup.string().required("Required"),
      }),
    }),

    handleSubmit: (values) => {
      console.log("values from[handleSubmit]", values);
      const signInPayload = {
        Phone: localStorage.getItem("userPhone"),
      };

      if (values.PhoneNumber.length === 10 || props.applyingForMe) {
        createContact(signInPayload)
          .then((resp) => {
            localStorage.setItem("applyingForSelf", applyingForSelf);
            // console.log("contact id by phone", resp);
            // alert("1.you are applying for : " + currentRow.academicProgram);

            getContactInfo(resp.ContactId).then((data) => {
              localStorage.setItem("firstName", data.First_Name);
              localStorage.setItem("lastName", data.Last_Name);
              history.push({
                pathname: `/intro/${currentRow.programId}`,
                search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
                state: {
                  academicProgramDetails: currentRow,
                  userDetails: {
                    ...data,
                    phoneNumber: localStorage.getItem("userPhone"),
                    email: data.Email,
                    relationWithApplicant: values.Relation,
                    contactID: resp.ContactId,
                    applyingForSelf: values.applyingForSelf,
                    ApplicantAccount: resp.ApplicantAccount,
                    RelationsAccount: resp.RelationsAccount,
                    First_Name: data.First_Name,
                    Last_Name: data.Last_Name,
                  },
                  applicationDetails: {
                    draft: false,
                  },
                  ParentId: resp.ContactId,
                  Email: data.Email,
                },
              });
              // state: `${programID}`
            });
          })
          .catch((error) => {
            console.log("Error in modal while create contact", error);
          });
      } else {
        //handle snackBar
        console.log("invalid phone number", values.PhoneNumber);
        handleSnackbarOpen("error", "Invalid PhoneNumber. Please try again.");
      }
    },

    displayName: "ExistingInformation",
  })(ExistingForm);

  return <ExistingFormik {...props} />;
};
